/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function(){
  $('.faq-accordion dd').attr('aria-hidden',true);
  $('.faq-accordion dt button').on('click',function(evt){
    evt.preventDefault();
    var state = $(this).attr('aria-expanded') === 'false' ? true : false;
    $(this).attr('aria-expanded',state);
    $(this).parent().next().slideToggle();
    $(this).parent().next().attr('aria-hidden',!state);
    return false;
  });
  
  // PDP

  if ( typeof $.fn.slick != 'undefined') {
    $('.slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight :true,
      fade: false,
      swipe: false,
      asNavFor: '.slider-nav-thumbnails'
    });

    $('.slider-nav-thumbnails').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      asNavFor: '.slider',
      dots: false,
      centerMode: true,
      focusOnSelect: true
    });
  }

//   // Remove active class from all thumbnail slides
//   $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

//   // Set active class to first thumbnail slides
//   $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

//   // On before slide change match active thumbnail to current slide
//   $('.slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
//     var mySlideNumber = nextSlide;
//     $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
//     $('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
//   });
  
  
  
  

  $('.product__description_readMore').on('click', function(){
    $('.product__description--extend').removeClass('hide');
    $(this).hide();
  });

});